import CloseIcon from '@mui/icons-material/Close'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import IconButton from '@mui/material/IconButton'
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar'
import React from 'react'

import useAppContext from '../../hooks/useAppContext'

type OmittedProps = 'open' | 'onClose' | 'message'
export interface GlobalSnackbarProps extends Omit<SnackbarProps, OmittedProps> {
  message: string | JSX.Element
  open?: boolean
  title?: string
  onClose?: () => void
  severity?: 'success' | 'info' | 'warning' | 'error'
}

export default function GlobalSnackbar(props: GlobalSnackbarProps): JSX.Element {
  const {
    message,
    title,
    severity = 'success',
    autoHideDuration = 5000,
  } = props

  const { setGlobalSnackbarProps } = useAppContext()

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string): void => {
    if (reason === 'clickaway') {
      return
    }

    setGlobalSnackbarProps?.(null)
  }

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  )

  return (
    <Snackbar
      open
      action={action}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity ?? 's'} sx={{ width: '100%' }}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  )
}
